import styled, { css } from 'styled-components'

const legacyDropdownPosition = css`
  margin-top: 90px;
  right: 110px;
  top: -40px;
`

export const StyledDropdown = styled.div<{ $portaled?: boolean }>`
  position: absolute;
  background-color: #ffffff;
  min-width: 300px;
  box-shadow: 0px 8px 24px 0px rgba(0, 0, 0, 0.18);
  padding: 12px 16px;
  z-index: 2;
  border-radius: 4px;
  overflow-y: auto;
  border: 1px solid #e2e8f0;

  ${props =>
    props.$portaled
      ? css`
          z-index: 1101;
          max-height: calc(100vh - 80px);
        `
      : css`
          ${legacyDropdownPosition}
          max-height: 40%;
        `}
`

export const DropdownBackdrop = styled.div<{ $portaled?: boolean }>`
  position: fixed;
  inset: 0;
  z-index: ${props => (props.$portaled ? 1100 : 1)};
  background: rgba(0, 0, 0, 0.35);
`
